import { workflowApi, axiosRequest } from "../../configs/axios.config";
import { commonsHelper } from "../../../helpers";
import { AIO_HIRING_WORKFLOW_APP_MODULE_NAMES } from "./hiring_workflow_app_modules";
class WorkflowsService {
  listUsers(tokens = [], page = 1, items = 10000, term = "") {
    const q = {
      page: page,
      items: items,
      query: { match_all: {} },
    };

    if (tokens.length) {
      q.query = { bool: { filter: { terms: { _id: tokens } } } };
    } else if (term) {
      q.query = {
        bool: {
          should: [
            { wildcard: { name: { value: term + "*" } } },
            { wildcard: { lastname: { value: term + "*" } } },
          ],
        },
      };
    }
    return workflowApi.post(`/users/search?page=${page}&items=${items}`, q);
  }
  fetchWorkflowsConfig(success, error) {
    return workflowApi
      .post("/workflow_configurations/search", {
        items: 1000,
        page: 1,
        q: {
          app_module_name_in: AIO_HIRING_WORKFLOW_APP_MODULE_NAMES,
          status_eq: "active",
          app_module_status_eq: "active",
        },
      })
      .then(({ data }) => success(data))
      .catch(error);
  }
  fetchUsers(token_list = [], term = "", page = 1, items = 100) {
    let terms =
      term.trim().length > 0
        ? term
            .trim()
            .split(" ")
            .map((t) => `*${t}*`)
            .join(" ")
        : null;
    let q;
    if (terms) {
      q = {
        query: {
          bool: {
            should: [
              {
                query_string: {
                  query: terms,
                  fields: ["name", "lastname"],
                },
              },
              { terms: { _id: token_list } },
            ],
          },
        },
      };
    } else {
      q = {
        query: {
          bool: {
            should: [{ terms: { _id: token_list } }],
          },
        },
      };
    }
    return workflowApi.post(`/users/search?page=${page}&items=${items}`, q);
  }
  listRequestTypes(page = 1, items = 10) {
    const q = {
      module_name_eq: process.env.RANKMI_MODULE || "rkm_14",
    };
    return workflowApi.post(
      `/request_types/search?page=${page}&items=${items}`,
      { q }
    );
  }
  showWorkflowConfigurations(id) {
    return workflowApi.get(`/workflow_configurations/${id}`);
  }
  createWorkflowConfigurations(data) {
    return workflowApi.post("/workflow_configurations", data);
  }
  listWorkflowConfigurations(token = "", page = 1, items = 10, filters = {}) {
    const q = {};

    if (Object.keys(filters).length) {
      q.name_cont = filters.workflowConfigurationName;
      q.state_in = filters.status;
      q.step_count_in = filters.stages;
    }
    return workflowApi
      .post(
        `/workflow_configurations/search?token=${token}&page=${page}&items=${items}`,
        { q }
      )
      .then(({ data, headers }) => {
        const mainData = {
          data,
          meta: commonsHelper.buildMetadata(
            headers["current-page"],
            headers["total-pages"],
            headers["total-count"]
          ),
        };

        return mainData;
      });
  }
  adminListWorkflowConfigurations(page = 1, items = 10, filters = {}) {
    const q = {};

    if (Object.keys(filters).length) {
      q.name_cont = filters.workflowConfigurationName;
      q.state_in = filters.status;
      q.step_count_in = filters.stages;
    }
    return workflowApi
      .post(
        `/workflow_configurations/settings_search?page=${page}&items=${items}`,
        { q }
      )
      .then(({ data, headers }) => {
        const mainData = {
          data,
          meta: commonsHelper.buildMetadata(
            headers["current-page"],
            headers["total-pages"],
            headers["total-count"]
          ),
        };

        return mainData;
      });
  }
  updateWorkflowConfigurations(id, data) {
    return workflowApi.patch(`/workflow_configurations/${id}`, data);
  }
  deleteWorkflowConfigurations(id) {
    return workflowApi.delete(`/workflow_configurations/${id}`);
  }
  activateWorkflowConfigurations(id) {
    return workflowApi.post(`/workflow_configurations/${id}/activate`);
  }
  deactivateWorkflowConfigurations(id) {
    return workflowApi.post(`/workflow_configurations/${id}/deactivate`);
  }
  createWorkflowConfigurationsSteps(id, data) {
    return workflowApi.post(`/workflow_configurations/${id}/set_steps`, data);
  }
  listWorkflowSteps(id) {
    return workflowApi.get(
      `/workflow_configurations/${id}/workflow_steps/search`
    );
  }
  listUserRequest(page, items, filters = {}) {
    const q = {};

    if (Object.keys(filters).length) {
      q.workflow_configuration_id_in = filters.workflowConfigurationId;
      q.user_token_in = filters.userToken;
      q.state_in = filters.state;
    }

    return workflowApi
      .post(`/requests/search?page=${page}&items=${items}`, {
        q,
      })
      .then(({ data, headers }) => {
        const mainData = {
          data,
          meta: commonsHelper.buildMetadata(
            headers["current-page"],
            headers["total-pages"],
            headers["total-count"]
          ),
        };

        return mainData;
      });
  }
  listUserOwnership(page, items, filters = {}) {
    const q = {};

    if (Object.keys(filters).length) {
      q.workflow_configuration_id_in = filters.workflowConfigurationId;
      q.user_token_in = filters.userToken;
      q.state_in = filters.state;
    }

    return workflowApi
      .post(`/requests/owned?page=${page}&items=${items}`, { q })
      .then(({ data, headers }) => {
        const mainData = {
          data,
          meta: commonsHelper.buildMetadata(
            headers["current-page"],
            headers["total-pages"],
            headers["total-count"]
          ),
        };

        return mainData;
      });
  }
  listHistoryRequests(page, items, filters = {}) {
    const q = {};

    if (Object.keys(filters).length) {
      q.workflow_configuration_id_in = filters.workflowConfigurationId;
      q.user_token_in = filters.userToken;
      q.state_in = filters.state;
    }

    return workflowApi
      .post(`/requests/history?page=${page}&items=${items}`, { q })
      .then(({ data, headers }) => {
        const mainData = {
          data,
          meta: commonsHelper.buildMetadata(
            headers["current-page"],
            headers["total-pages"],
            headers["total-count"]
          ),
        };

        return mainData;
      });
  }
  dropUserRequest(userToken, id) {
    return workflowApi.post(`/users/${userToken}/requests/${id}/drop`);
  }
  listCurrentParticipantsRequest(page, items, filters = {}) {
    const q = {};

    if (Object.keys(filters).length) {
      q.workflow_configuration_id_in = filters.workflowConfigurationId;
      q.user_token_in = filters.userToken;
      q.state_in = filters.state;
    }

    return workflowApi
      .post(`/requests/waiting_approval?page=${page}&items=${items}`, { q })
      .then(({ data, headers }) => {
        const mainData = {
          data,
          meta: commonsHelper.buildMetadata(
            headers["current-page"],
            headers["total-pages"],
            headers["total-count"]
          ),
        };

        return mainData;
      });
  }
  listOldParticipantsRequest(userToken) {
    return workflowApi.get(`/participants/${userToken}/requests/historic`);
  }
  approveParticipantsRequest(userToken, id) {
    return workflowApi.post(
      `/participants/${userToken}/requests/${id}/approve`
    );
  }
  rejectParticipantsRequest(userToken, id) {
    return workflowApi.post(`/participants/${userToken}/requests/${id}/reject`);
  }
  createRequest(data) {
    return workflowApi.post("/requests", data);
  }
  showRequest(id) {
    return workflowApi.get(`/requests/${id}`).then(({ data }) => data);
  }
  approveRequest(id, comment) {
    return workflowApi.post(`/requests/${id}/approve`, {
      comment,
    });
  }
  rejectRequest(id, comment) {
    return workflowApi.post(`/requests/${id}/reject`, {
      comment,
    });
  }
  dropRequest(id) {
    return workflowApi.post(`/requests/${id}/drop`);
  }
  deleteRequest(id) {
    return workflowApi.delete(`/requests/${id}`);
  }
  getStructure(workflowConfigurationId) {
    return workflowApi.get(
      `/workflow_configurations/${workflowConfigurationId}/structure`
    );
  }
  getRequestType(id) {
    return workflowApi.get(`/request_types/${id}`);
  }
  getCurrentStructure(requestId) {
    return workflowApi.get(`/requests/${requestId}/current_structure`);
  }
  getStructureElementsByStep(requestId) {
    return workflowApi.get(
      `/requests/${requestId}/request_workflow_steps/structures`
    );
  }
  updateRequestData(requestId, data) {
    return workflowApi.post(`/requests/${requestId}/add_data`, { data });
  }
  getFileUploadUrl(fileName) {
    return workflowApi.put(`/uploads/presigned_url?file_name=${fileName}`);
  }
  getFileDownloadUrl(fileName) {
    return workflowApi.get(`/uploads/presigned_url?file_name=${fileName}`);
  }
  uploadUrl(url, contentType, content) {
    return workflowApi.post(`/uploads/presigned_url`, {
      url,
      content,
      content_type: contentType,
    });
  }
  downloadUsrRequests(filters = {}) {
    const q = {};

    if (Object.keys(filters).length) {
      q.workflow_configuration_id_in = filters.workflowConfigurationId;
      q.user_token_in = filters.userToken;
      q.state_in = filters.state;
    }

    return workflowApi.post("/requests/export", { q });
  }
  cloneWorkflowConfiguration(workflowConfigurationId) {
    return workflowApi.post(
      `/workflow_configurations/${workflowConfigurationId}/clone`,
      {}
    );
  }
}

export const workflowsService = new WorkflowsService();
